<template>
  <ToggleSection label="Link to ELN" :collapsed="!dv.isEditing">
    <FieldGrid
      class="form-fields"
      :fields="[['used_in_experiments'], ['from_experiments']]"
      :dv="dv"
    />
  </ToggleSection>
</template>

<script>
import ToggleSection from '@/components/fields/ToggleSection.vue'
import FieldGrid from '@/components/fields/FieldGrid.vue'

export default {
  name: 'SampleLinkToELN',
  components: { ToggleSection, FieldGrid },
  props: {
    dv: { type: Object, required: true },
  },
}
</script>
